module.exports = __webpack_public_path__ + "img/1-7.db48e2ea.png";